<template>
  <div>
    <v-card flat class="py-0 mx-4 my-6">
      <v-tabs v-model="tab">
        <v-tab
          v-for="(item, index) in expansionPanels"
          class="text-none black--text"
          :class="index === tab ? 'white primary--text' : ''"
          :key="item.title"
        >
          {{ $t(item.title) }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in expansionPanels" :key="item.title">
          <v-card flat>
            <v-card-text v-if="item.table === 'UNIT_TYPE'">
              <unit-type-data-table />
            </v-card-text>
            <v-card-text v-if="item.table === 'PROPERTY_TYPE'">
              <property-type-data-table />
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <!-- <v-expansion-panels
      flat
      class="py-0 my-0 ps-md-3 pe-md-3"
      v-model="panel"
      multiple
    >
      <v-expansion-panel class="my-5 px-0 mx-0" v-for="(item, index) in expansionPanels" :key="index">
        <v-expansion-panel-header>
          <template v-slot:actions>
            <v-icon color="primary"> mdi-chevron-down </v-icon>
          </template>
          <v-container fluid>
            <v-row class="justify-space-between ma-0">
              <h3 class="my-2 mx-2 primary--text">
                {{ $t(item.title) }}
              </h3>
              <v-spacer></v-spacer>
              <v-text-field
                v-if="item.table === 'UNIT_TYPE'"
                :label="$t('common.search')"
                v-model="search"
                 @click.native.stop
                @input="searchTable(item.table)"
                class="mx-2"
                outlined
                dense>
              </v-text-field>
              <v-text-field
                v-else
                :label="$t('common.search')"
                v-model="search1"
                 @click.native.stop
                @input="searchTable(item.table)"
                class="mx-2"
                outlined
                dense>
              </v-text-field>
              <v-btn
                outlined
                rounded
                @click="exportData(item.table)"
                @click.native.stop
                :class="!$vuetify.breakpoint.smAndUp ? 'my-2'  : ''"
                class="primary mx-2 white--text text-none"
              >
                <v-icon small class="mx-2">
                  mdi-application-export
                </v-icon>
                {{
                  $t("common.excel")
                }}
              </v-btn>
              <v-btn
                rounded
                @click.native.stop
                v-if="item.btnTitle"
                class="primary text-none"
                @click="showRightSideDrawer(item.table)"
                depressed
                :class="!$vuetify.breakpoint.smAndUp ? 'my-2'  : ''">
                <v-icon size="20" left>mdi-plus</v-icon>
                {{ $t(item.btnTitle) }}
              </v-btn>
            </v-row>
          </v-container>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <template v-if="item.table === 'UNIT_TYPE'"><unit-type-data-table/></template>
          <template v-if="item.table === 'PROPERTY_TYPE'"><property-type-data-table/></template>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels> -->
    <side-drawer>
      <template slot="formDetails">
        <!-- <template v-if="propertyFormName === 'UNIT'"><unit-form/></template> -->
        <template v-if="propertyFormName === 'PROPERTY_TYPE'"
          ><property-type-form
        /></template>
        <template v-if="propertyFormName === 'UNIT_TYPE'"
          ><unit-type-form
        /></template>
        <!-- <template v-if="propertyFormName === 'PROPERTY'"><property-form/></template> -->
      </template>
    </side-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      // panel: [0, 1],
      tab: Number(localStorage.getItem("propertyTab")) || 0,
      search: null,
      search1: null
    };
  },
  watch: {
    tab(val) {
      localStorage.setItem("propertyTab", val);
    }
  },
  components: {
    "side-drawer": () => import("@/core/components/SideDrawer"),
    "unit-type-form": () =>
      import("@/property/components/rightSideDrawer/UnitTypeForm.vue"),
    "unit-type-data-table": () =>
      import("@/property/components/UnitTypeDataTable.vue"),
    "property-type-form": () =>
      import("@/property/components/rightSideDrawer/PropertyTypeForm.vue"),
    "property-type-data-table": () =>
      import("@/property/components/PropertyTypeDataTable.vue")
    // 'property-form': () => import("@/property/components/rightSideDrawer/PropertyForm.vue"),
    // 'property-data-table': () => import("@/property/components/PropertyDataTable.vue"),
    // 'unit-form': () => import("@/property/components/rightSideDrawer/UnitForm.vue"),
    // 'unit-data-table': () => import("@/property/components/UnitDataTable.vue")
  },
  computed: {
    ...mapGetters(["propertyFormName"]),
    expansionPanels() {
      return [
        {
          title: "property.propertyType.title",
          btnTitle: "property.propertyType.btnTitle",
          table: "PROPERTY_TYPE"
        }
        // { title: 'property.unit.title', btnTitle: 'property.unit.btnTitle', table: 'UNIT' },
        // {
        //   title: "property.unitType.title",
        //   btnTitle: "property.unitType.btnTitle",
        //   table: "UNIT_TYPE"
        // }
        // { title: 'property.property.title', btnTitle: 'property.property.btnTitle', table: 'PROPERTY' },
      ];
    }
  },
  methods: {
    exportData(item) {
      if (item === "UNIT_TYPE") {
        this.$root.$emit("exportUnitType");
      } else {
        this.$root.$emit("exportPropertyType");
      }
    },
    searchTable(item) {
      if (item === "UNIT_TYPE") {
        this.$root.$emit("searchUnitType", this.search);
      } else {
        this.$root.$emit("searchPropertyType", this.search1);
      }
    },
    showRightSideDrawer(item) {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
      this.$store.commit("PROPERTY_FORMNAME", item);
    }
  }
};
</script>

<style></style>
